import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemSharedDashboardsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-shared-dashboards',
	path: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
};
